import { useSessionStore } from '@/lib/session.store'
import { decodeSessionClaims } from '@/lib/session-claims'
import { isSeasonOpen } from './season'

const ELIGIBLE_DOMAIN = 'socialcommerceclub.com'

/** Exact-domain match, case-insensitive; rejects lookalike domains and local parts containing '@'. */
export function isEligibleEmail(email: string): boolean {
  const normalized = email.trim().toLowerCase()
  const at = normalized.lastIndexOf('@')
  if (at <= 0) return false
  const local = normalized.slice(0, at)
  const domain = normalized.slice(at + 1)
  return !local.includes('@') && domain === ELIGIBLE_DOMAIN
}

function isEligibleSession(status: string, token: string | null, email: string): boolean {
  if (status !== 'ready' || !token) return false
  if (decodeSessionClaims(token)?.audience !== 'staff') return false
  return isEligibleEmail(email) && isSeasonOpen()
}

/** Same rule as the hook, for route guards that run outside React. */
export function isHalloweenEligibleNow(): boolean {
  const { sessionStatus, token, user } = useSessionStore.getState()
  return isEligibleSession(sessionStatus, token, user.email)
}

export function useHalloweenEligible(): boolean {
  const status = useSessionStore((s) => s.sessionStatus)
  const token = useSessionStore((s) => s.token)
  const email = useSessionStore((s) => s.user.email)
  return isEligibleSession(status, token, email)
}
